import { Component } from '@angular/core';
import {ContactForm} from '../../components/contact-form/contact-form';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-contact-page',
  imports: [
    ContactForm,
    TranslatePipe
  ],
  templateUrl: './contact-page.html',
  styles: ``
})
export class ContactPage {

}
